<script setup lang="ts">
interface FeatureGroup {
  title: string;
  desc: string;
  descList: string[];
  icon: string;
  mainImage: string;
  direction: 'copywriting-to-image' | string; // 可根据实际值使用联合类型
  extraCardBackColor: string;
  extraTitleClass: string;
}

interface FeaturesIntroduction {
  title: string;
  desc: string;
  groups: FeatureGroup[];
}

// 完整数据结构
interface ProductData {
  content: FeaturesIntroduction;
}
const extraCardBackColor = 'bg-[linear-gradient(180deg,#FBFDFF_0%,#F9FCFF_100%)]'
const props = withDefaults(defineProps<ProductData>(), {
  content: () => ({
    title: '产品功能介绍',
    desc: '我们提供强大的功能来满足您的业务需求',
    extraCardBackColor: extraCardBackColor,
    groups: [
      {
        title: '核心功能',
        desc: '详细描述核心功能的特点和优势',
        descList: [
          '功能点1：提供高效的解决方案',
          '功能点2：确保数据安全可靠',
          '功能点3：支持多平台操作'
        ],
        icon: '/images/function-icon-1.png',
        mainImage: '/images/function-main-1.png',
        direction: 'copywriting-to-image'
      },
      {
        title: '高级特性',
        desc: '更多高级特性和扩展功能',
        descList: [
          '特性1：智能化操作体验',
          '特性2：自定义配置选项',
          '特性3：实时数据同步'
        ],
        icon: '/images/function-icon-2.png',
        mainImage: '/images/function-main-2.png',
        direction: 'image-to-copywriting'
      }
    ]
  })
})
</script>

<template>
  <section class="page-function w-full mt-14rem max-ml:mt-0">
    <PageTitle :title="props.content.title" :extraBackClass="props.content.extraTitleClass"
      :extraTitleStyle="{ paddingBottom: '0' }" />
    <section
      :class="['py-4.1rem', group.direction === 'copywriting-to-image' ? '' : props.content.extraCardBackColor ? props.content.extraCardBackColor : extraCardBackColor]"
      v-for="group in props.content.groups">
      <PageContentCenter
        :class="['flex', 'justify-center', 'gap-160px', 'relative', group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
        <div class="w-350px relative align-self-center max-lg:w-100%">
          <div :class="['mb-1.75rem']">
            <Pic :src="group.icon" class="w-[5.5rem] h-[5rem] mb-1.75rem max-ml:hidden"></Pic>
            <h4 class="text-1.6rem">{{ group.title }}</h4>
          </div>
          <ul class="features-group-ul">
            <li v-for="desc in group.descList" class="text-[#616671] text-[1rem] mb-[2rem] features-group-li">{{
              desc
            }}
            </li>
          </ul>
        </div>
        <Pic class="w-42.25rem max-ml:w-100%" :src="group.mainImage" :style="{}"></Pic>
      </PageContentCenter>
    </section>
  </section>
</template>

<style lang="scss" scoped>
.page-function {
  position: relative;

  .titleLine {
    position: relative;
    padding-left: 30px;

    &::before {
      position: absolute;
      top: 50%;
      left: 12px;
      width: 2px;
      height: 18px;
      margin-top: -7px;
      background-color: #c2cde5;
      content: "";
    }
  }
}
</style>
